import React, { useEffect, useState } from "react";
import "./AdminPanel.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import { useSelector } from "react-redux";
import { getUser } from "../features/userSlice";
import { useHistory } from "react-router-dom";
import { storage } from "../config/firebase";
import firebase from "firebase";
import Dropzone from "react-dropzone";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { Add } from "@material-ui/icons";

const AdminPanel = () => {
  const user = useSelector(getUser);
  console.log(user);

  const history = useHistory();

  const [progress, setProgress] = useState(0);
  const [category, setCategory] = useState("");
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [frontEnd, setFrontEnd] = useState("");
  const [backEnd, setBackEnd] = useState("");
  const [db, setDb] = useState("");
  const [language, setLanguage] = useState("");
  const [imageURL1, setImageURL1] = useState("");
  const [imageURL2, setImageURL2] = useState("");
  const [imageURL3, setImageURL3] = useState("");

  const [contacts, setContacts] = useState([]);
  const [profile, setProfile] = useState({});

  const [showForm, setShowForm] = useState(false);
  const [showMessages, setShowMessages] = useState(false);

  useEffect(() => {
    if (user === null) {
      history.push("/");
    }
    return () => {};
  }, [profile]);

  const handleUpload = (files) => {
    if (user) {
      for (let i = 0; i < files.length; i++) {
        const uploadTask = storage
          .ref(`project-images/${files.item(i).name}`)
          .put(files.item(i));

        uploadTask.on(
          "state_changed",
          (snap) => {
            const progress = Math.round(
              (snap.bytesTransferred / snap.totalBytes) * 100
            );
            setProgress(progress);
          },
          (error) => {
            alert(error.message);
          },
          () => {
            storage
              .ref("project-images")
              .child(files.item(i).name)
              .getDownloadURL()
              .then((url) => {
                if (i === 0) {
                  setImageURL1(url);
                } else if (i === 1) {
                  setImageURL2(url);
                } else if (i === 2) {
                  setImageURL3(url);
                } else {
                  alert("Only 3 images can be uploaded");
                }
              });
          }
        );
      }
      alert("Images Uploaded Successfully");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (user) {
      firebase
        .firestore()
        .collection("ashwin-projects")
        .add({
          name,
          url,
          frontEnd,
          backEnd,
          db,
          language,
          category,
          imageURL1,
          imageURL2,
          imageURL3,
        })
        .then(() => {
          setName("");
          setUrl("");
          setCategory("");
          setFrontEnd("");
          setBackEnd("");
          setDb("");
          setLanguage("");
        })
        .catch((error) => {
          alert(error.message);
        });
    }
  };

  useEffect(() => {
    if (user) {
      firebase
        .firestore()
        .collection("ashwin-contact-form")
        .orderBy("timestamp", "desc")
        .onSnapshot((snap) => {
          setContacts(
            snap.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }))
          );
        });

      const profileRef = firebase
        .firestore()
        .collection("admin")
        .doc(user?.uid);

      profileRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            let data = doc.data();
            setProfile(data);
          } else {
            setProfile({});
          }
        })
        .catch(function (error) {
          setProfile({});
          console.log("Error getting document:", error);
        });
    }

    return () => {
      //
    };
  }, [user, contacts]);

  return (
    <div className="admin">
      <Header />
      <div className="admin-body">
        {user && profile?.isAdmin ? (
          <>
            <button
              className="add-button"
              onClick={() => setShowForm(!showForm)}
            >
              {showForm ? "Hide Form" : "Add New Website"} <Add />
            </button>
            <button
              className="add-button"
              onClick={() => setShowMessages(!showMessages)}
            >
              {showMessages ? "Hide Messages" : "Show Messages"}{" "}
              <NotificationsActiveIcon />
            </button>
            {showForm ? (
              <>
                <div className="container">
                  <progress value={progress} max="100" />
                  <Dropzone>
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div {...getRootProps()}>
                          <input
                            {...getInputProps()}
                            onDrop={(files) => handleUpload(files)}
                            onChange={(e) => handleUpload(e.target.files)}
                          />
                          <div className="dropzone">
                            <AttachFileIcon />
                            <p>Drag and drop file's here</p>
                          </div>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                  <form className="contact__form">
                    <h5>Category</h5>
                    <input
                      type="text"
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                      placeholder="Enter category"
                      required
                    />
                    <h5>Name</h5>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Enter name"
                      required
                    />
                    <h5>Front-End</h5>
                    <input
                      type="text"
                      value={frontEnd}
                      onChange={(e) => setFrontEnd(e.target.value)}
                      placeholder="Enter front end technology name"
                      required
                    />
                    <h5>Back-End</h5>
                    <input
                      type="text"
                      value={backEnd}
                      onChange={(e) => setBackEnd(e.target.value)}
                      placeholder="Enter back end technology name"
                      required
                    />
                    <h5>Database</h5>
                    <input
                      type="text"
                      value={db}
                      onChange={(e) => setDb(e.target.value)}
                      placeholder="Enter database name"
                      required
                    />
                    <h5>Language</h5>
                    <input
                      type="text"
                      value={language}
                      onChange={(e) => setLanguage(e.target.value)}
                      placeholder="Enter code language name"
                      required
                    />
                    <h5>URL</h5>
                    <input
                      type="text"
                      value={url}
                      onChange={(e) => setUrl(e.target.value)}
                      placeholder="Enter URL"
                      required
                    />
                    <button
                      className="add__image__btn btn btn-outline-success"
                      onClick={handleSubmit}
                    >
                      Upload
                    </button>
                  </form>
                </div>
                <div className="container">
                  {contacts.map(
                    ({ name, number, email, message, timestamp }) => (
                      <div className="contact__data">
                        <h4>
                          Name: <strong>{name}</strong>
                        </h4>
                        <h4>
                          Number: <strong>{number}</strong>
                        </h4>
                        <h4>
                          Email: <strong>{email}</strong>
                        </h4>
                        <h5>
                          Message: <br />
                          <strong>{message}</strong>
                        </h5>
                        <p className="time">
                          Time:{" "}
                          <strong>
                            {new Date(timestamp?.toDate()).toLocaleString()}
                          </strong>
                        </p>
                      </div>
                    )
                  )}
                </div>
              </>
            ) : null}

            {showMessages && !showForm ? (
              <div className="container">
                {contacts.map(({ name, number, email, message, timestamp }) => (
                  <div className="contact__data">
                    <h4>
                      Name: <strong>{name}</strong>
                    </h4>
                    <h4>
                      Number: <strong>{number}</strong>
                    </h4>
                    <h4>
                      Email: <strong>{email}</strong>
                    </h4>
                    <h4>
                      Message: <br />
                      <strong>{message}</strong>
                    </h4>
                    <p className="time">
                      Time:{" "}
                      <strong>
                        {new Date(timestamp?.toDate()).toLocaleString()}
                      </strong>
                    </p>
                  </div>
                ))}
              </div>
            ) : null}
          </>
        ) : (
          <div>404, Page not found!</div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default AdminPanel;
